import Link from "next/link"
import { Card, CardBody } from "reactstrap"

import { IProjectFollowership } from "@api/schema"
import { withDynamicNamespaces } from "@components/hoc/withDynamicNamespaces"
import FollowButton from "@components/project/common/FollowButton"
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n"
import { projectNameTextWithDynamicNamespaces } from "@services/projectHelper"
import { Routes, routeWithParams } from "@services/routes"
import { idFromIModelOrIRI, slugOrIdFromISlugAndNumericIdentifierModelOrIRI } from "@services/util"


const usedNamespaces: NamespaceShortcut[] = ["project"]

interface IProps {
  projectFollowership: IProjectFollowership
  /**
   * @see FollowButton/IProps/allowWithdrawalOfOnboardingFollowshipInsteadOfModal
   */
  allowWithdrawalOfOnboardingFollowshipInsteadOfModal?: boolean
}

/**
 * This component provides a card for a single project followership a user has.
 */
const FollowershipCard: React.FC<IProps> = (props: IProps) => {
  const {
    projectFollowership,
    allowWithdrawalOfOnboardingFollowshipInsteadOfModal,
  } = props
  const t = useDynamicTranslation()

  // @todo eventually check data type of projectFollowership.project:
  // As for now (2023-09-26) it'll be always an IProject, since the backend provideds followerships only for user.get(self)
  // and in this case, it never puts a string.
  // HOWEVER there may be future cases

  return <Link passHref href={routeWithParams(Routes.ProjectPage, { slug: slugOrIdFromISlugAndNumericIdentifierModelOrIRI(projectFollowership.project) })}>
    <a className="no-link-underline">
      <Card
        id={`projectfollowershipcard_${idFromIModelOrIRI(projectFollowership.project)}`}
        className={"followership-card clickable dancing"}
      >
        <CardBody className="followership-card__body">
          {projectNameTextWithDynamicNamespaces(projectFollowership.project, t)}
          <FollowButton
            project={projectFollowership.project}
            showFollowershipCount={false}
            allowWithdrawalOfOnboardingFollowshipInsteadOfModal={allowWithdrawalOfOnboardingFollowshipInsteadOfModal}
          />
        </CardBody>
      </Card>
    </a>
  </Link>
}

export default withDynamicNamespaces<IProps>(FollowershipCard, usedNamespaces)